import { useSnackbarStore } from 'stores/zustand/snackbarStore';

const tweet = (text: string, url?: string, via?: string): void => {
    const twitterParameters = [];

    if (!!url) {
        twitterParameters.push('url=' + encodeURI(url));
    }
    if (!!via) {
        twitterParameters.push('via=' + encodeURI(via));
    }
    twitterParameters.push('text=' + encodeURIComponent(text));
    const postUrl = 'https://twitter.com/intent/tweet?' + twitterParameters.join('&');
    window.open(postUrl, '_blank');
};

const copyToClipboard = (text: string, dontPushSnackbar?: boolean): void => {
    navigator.clipboard.writeText(text);
    if (dontPushSnackbar) {
        return;
    }
    useSnackbarStore.getState().actions.pushMessage({
        text: 'Copied to clipboard!',
        variant: 'positive',
    });
};

export const maxSocialCharacterLimit = 800;

export { tweet, copyToClipboard };
